import { render, staticRenderFns } from "./PhoneWrapper.vue?vue&type=template&id=8cb7b144&scoped=true"
import script from "./PhoneWrapper.vue?vue&type=script&lang=js"
export * from "./PhoneWrapper.vue?vue&type=script&lang=js"
import style0 from "./PhoneWrapper.vue?vue&type=style&index=0&id=8cb7b144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb7b144",
  null
  
)

export default component.exports